import { useLocalization } from "@fluent/react";
import { Box } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import EmailIcon from "@mui/icons-material/Email";
import { DepartmentNotificationTargetEnum } from "../companyDepartmentsSlice";

type Props = {
    value?: DepartmentNotificationTargetEnum;
};

export const DepartmentNotificationTargetLabel = ({ value }: Props) => {
    const { l10n } = useLocalization();

    const renderContent = () => {
        switch (value) {
            case DepartmentNotificationTargetEnum.MembersOnly:
                return {
                    icon: <GroupsIcon fontSize="small" />,
                    label: l10n.getString(
                        "company-department-notification-target-members-only",
                        null,
                        "Tylko członkowie działu"
                    )
                };

            case DepartmentNotificationTargetEnum.DepartmentEmailOnly:
                return {
                    icon: <EmailIcon fontSize="small" />,
                    label: l10n.getString(
                        "company-department-notification-target-department-email-only",
                        null,
                        "Tylko email działu"
                    )
                };

            case DepartmentNotificationTargetEnum.MembersAndDepartmentEmail:
                return {
                    icon: (
                        <Box sx={{ display: "flex", gap: 0.5 }}>
                            <GroupsIcon fontSize="small" />
                            <EmailIcon fontSize="small" />
                        </Box>
                    ),
                    label: l10n.getString(
                        "company-department-notification-target-members-and-email",
                        null,
                        "Członkowie + email działu"
                    )
                };

            default:
                return { icon: null, label: "-" };
        }
    };

    const content = renderContent();

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {content.icon}
            <span>{content.label}</span>
        </Box>
    );
};